
import Input from "../Input";
import Output from "../Output";
import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";



function AngolNemet({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Angol német fordító</title>
                <meta name='description' content="Angol német pontos fordítás azonnal. Csak másold vagy írd be a lefordítandó szöveget, és nyomd meg a 'fordítás' gombot!" />
                <meta title="Angol-német fordító" />
                <link rel="canonical" href="https://online-fordito.hu/angol-nemet-fordito" />
            </Helmet>
            <h1>Angol német fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <h2>Az angol és német nyelvről</h2>

                Az angol és a német a germán nyelvcsalád nyugati germán ágához tartozó két, egymással szoros rokonságban álló nyelv. Közös ősük az úgynevezett protogermán, amelyet a korai középkorban beszéltek. Az idők során az angol és a német nyelv különálló nyelvekké fejlődött, amelyeknek sajátos jellegzetességeik vannak, de bizonyos hasonlóságok még mindig megmaradtak.

                <h3>Hasonlóságok</h3>
                <ul>

                <li><b>Szókincs</b>: Az angol és a német nyelv a közös germán gyökerek miatt jelentős mennyiségű szókincsben osztozik. Sok alapvető szó, mint például a "ház" (Haus), "apa" (Vater) és "víz" (Wasser), mindkét nyelvben hasonló vagy azonos alakban szerepel. Ez a hasonlóság gyakran megkönnyíti az egyik nyelv beszélői számára, hogy felismerjenek és megértsenek bizonyos szavakat a másik nyelvben.</li>

                <li><b>Nyelvtan</b>: Az angol és a német nyelv nyelvtani felépítése hasonló. Mindkettő flektált nyelv, amelyekben a névelők, névmások és melléknevek eset, nem és szám szerint eltérő alakban szerepelnek. Mindkét nyelvben van főnévi deklinációs rendszer, bár a német nyelvben az angol egyszerűsített rendszeréhez képest a német nyelvben bonyolultabb a deklinációs rendszer, négy esetet (nominativus, akkuzatív, dativus és genitivus) tartalmaz.</li>

                <li><b>Mondatszerkezet</b>: Az angol és a német mondatszerkezet hasonló, az alapvető szórend az alany-ige-tárgy (SVO). Ez azt jelenti, hogy az alany jellemzően az ige előtt áll, majd a tárgy következik. A német azonban rugalmasabb szórendet alkalmaz, ami nagyobb változatosságot tesz lehetővé, és lehetővé teszi, hogy a szóelhelyezéssel a mondat különböző részeit hangsúlyozzuk.</li>

                </ul>

                <h3>Különbségek</h3>

                <ul>

                <li><b>Kiejtés</b>: Az angol és a német nyelv hangtani rendszere eltérő. Az angolban a magánhangzók széles skálája, valamint a hangsúlyok és a hangsúlyozási minták összetett rendszere található. A német kiejtés ezzel szemben következetesebb és kiszámíthatóbb, a magánhangzók szűkebb körével és a hangsúlyok elhelyezésének egyértelműbb szabályaival.</li>

                <li><b>Szókincs</b>: Bár az angol és a német nyelv számos rokon értelmű szókincsben osztozik, szókincsükben is jelentős különbségek vannak. Az angol sokat kölcsönzött más nyelvekből, különösen a latinból, a franciából és a görögből, ami nagyobb szókincset és változatosabb szinonimákat eredményezett. A német nyelv ezzel szemben megőrizte germán alapú szókincsét, kevesebb kölcsönszóval.</li>

                <li><b>Nyelvtani jellemzők</b>: Az angol és a német nyelvtanban van néhány nyelvtani különbség. A német nyelvtan nemek szerinti rendszerben a főneveket három nem (hímnemű, nőnemű vagy nemtelen) egyikébe sorolják, és nemspecifikus névelőket és melléknévvégződéseket írnak elő. Ezzel szemben az angol nyelvben a nyelvtani nemek megkülönböztetése nagyrészt megszűnt. A német nyelvben az igekötők ragozási rendszere is kiterjedtebb, a különböző személyekre és számokra külön igekötőkkel, míg az angolban az igekötők ragozása egyszerűsített.</li>

                <li><b>Szórend</b>: Az angol és a német nyelv alapvető SVO (alany-állítmány-tárgy) szórendje közös, a mondatszerkezetben azonban vannak különbségek. Az angolban általában szigorúbb a szórend, és kevésbé rugalmas a mondatelemek átrendezése. A német nyelv több variációt tesz lehetővé a szórendben, és az alárendelő kötőszavak szélesebb körű rendszerét használja a mondaton belüli különböző alárendeltségi szintek jelölésére.</li>
                </ul>
                <p>Összességében az angol és a német szoros rokonságban álló nyelvek, amelyekben vannak hasonlóságok és különbségek egyaránt. Közös germán eredetük megalapozza a kölcsönös megértést és a közös nyelvi jellemzőket, de a történelmi, kulturális és nyelvi hatásoknak köszönhetően mindkét nyelvnek kialakultak a saját jellegzetességei.</p>
                

            </section>
        </>

    )
}

export default AngolNemet;